var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.load),expression:"load"}],staticClass:"loading-more",attrs:{"infinite-scroll-distance":"50","infinite-scroll-disabled":_vm.disabled}},[_vm._t("default"),_c('morebar',{attrs:{"status":_vm.status},on:{"onmore":_vm.load}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }